import React, { useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { Icon } from '@iconify/react';
import {
  Button,
  ListGroup,
  ListGroupItem,
  Modal,
  ModalBody,
  ModalHeader
} from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { removeCallQueue } from '../actions';
import { getDatetimeLocal } from '../helpers/utilities';

const CallbackQueue = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const items = useSelector(selector => selector.callQueue.items);
  const referralItems = useSelector(selector => selector.referral.data);
  const queueItems = useMemo(() => items.map(item => {
    const referralCase = (referralItems || []).find(referralItem => referralItem.refCode === item.refCode);
    return {
      ...item,
      patientFirstName: referralCase?.patientFirstName || item.patientFirstName,
      patientLastName: referralCase?.patientLastName || item.patientLastName
    };
  }), [items, referralItems]);

  if (queueItems.length === 0 || (pathname.startsWith('/telemed/') && !pathname.startsWith('/telemed/doctor/'))) return null;

  const openCase = item => {
    dispatch(removeCallQueue(item.refCode));
    setIsOpen(false);
    navigate(`/consult?data=${item.refCode}`);
  };

  return (
    <>
      <Button color="warning" className="position-fixed bottom-0 end-0 m-3 shadow" onClick={() => setIsOpen(true)}>
        <Icon icon="ion:call" className="me-1" />
        {`${t('Callback queue')} (${queueItems.length})`}
      </Button>
      <Modal isOpen={isOpen} toggle={() => setIsOpen(false)} centered>
        <ModalHeader toggle={() => setIsOpen(false)}>{t('Callback queue')}</ModalHeader>
        <ModalBody>
          <ListGroup>
            {queueItems.map(item => (
              <ListGroupItem key={item.refCode} className="d-flex align-items-center justify-content-between gap-2">
                <div>
                  <div className="text-sb">{`#${item.refCode}`}</div>
                  {item.patientFirstName && <div>{`${item.patientFirstName} ${item.patientLastName || ''}`}</div>}
                  <small>{getDatetimeLocal(new Date(Number(item.receivedAt)))}</small>
                </div>
                <Button color="primary" size="sm" onClick={() => openCase(item)}>{t('Open case')}</Button>
              </ListGroupItem>
            ))}
          </ListGroup>
        </ModalBody>
      </Modal>
    </>
  );
};

export default CallbackQueue;
